<template>
  <div>
    <div v-if="!departureDetails.departureLegs.length && departureDetails.departureNoFlights && departureDetails.returnNoFlights" class="departures__trips">
      <div class="departures__trips-row">
        <div class="departures__trip">
          <div class="departures__simple">
            <strong>Start Date:</strong>
            {{departureDetails.departureNoFlights.date}}
          </div>
          <div class="departures__simple">
            <strong>Location:</strong>
            {{departureDetails.departureNoFlights.location}}
          </div>
        </div>
        <div class="departures__trip">
          <div class="departures__simple">
            <strong>End Date:</strong>
            {{departureDetails.returnNoFlights.date}}
          </div>
          <div class="departures__simple">
            <strong>Location:</strong>
            {{departureDetails.returnNoFlights.location}}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="departures__trips">
      <div class="departures__trips-row">
        <TripDetails v-if="!departureDetails.allLegs.length" title="Depart" :legs="departureDetails.departureLegs" :brand="brand"></TripDetails>
        <TripDetails v-if="!departureDetails.allLegs.length" title="Return" :legs="departureDetails.returnLegs" :brand="brand"></TripDetails>
        <template v-if="departureDetails.allLegs.length">
            <div
                class="checkout-end__summary-section"
                v-for="(flight, index) in departureDetails.allLegs"
                :key="flight.carrierCode"
            >
                <h3 class="checkout-end__summary-section-title">Flight {{index + 1}}</h3>
                <div class="checkout-end__info">
                <b>Carrier</b>
                : {{flight.flightCarrier.name}}
                </div>
                <div class="checkout-end__info">
                <b>Departure point</b>
                : {{flight.departureAirport.name}}
                </div>
                <div class="checkout-end__info">
                <b>Departure date</b>
                : {{flight.departureDate | formatDate}}
                </div>
                <div class="checkout-end__info">
                <b>Departure time</b>
                : {{flight.departureDate | formatTime}}
                </div>
                <div class="checkout-end__info">
                <b>Arrival point</b>
                : {{flight.arrivalAirport.name}}
                </div>
                <div class="checkout-end__info">
                <b>Arrival date</b>
                : {{flight.arrivalDate | formatDate}}
                </div>
                <div class="checkout-end__info">
                <b>Arrival time</b>
                : {{flight.arrivalDate | formatTime}}
                </div>
            </div>
        </template>
      </div>
    </div>
    <div class="departures__html-wrapper" v-if="departureDetails.errata.length">
      <div class="row">
        <div class="departures__html">
          <ul>
            <li v-for="errata in departureDetails.errata" :key="errata" :value="errata">{{errata}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TripDetails from './TripDetails.vue';

export default {
  components: {
    TripDetails
  },
  props: ['departureDetails','brand']
};
</script>
